import z from 'zod';

export const authorizeUrlModel = z.object({
    authorizationUrl: z.string().url(),
});

export const openIdConnectConfigurationModel = z.object({
    audience: z.string().url(),
    authority: z.string().url(),
    authorizationEndpoint: z.string().url(),
    clientId: z.string().min(1),
    endSessionEndpoint: z.string(),
    issuer: z.string().url(),
    jwksUri: z.string().url(),
    redirectUri: z.string().url(),
    responseType: z.string(),
    scopes: z.string(),
    tokenEndpoint: z.string().url(),
});

export const authorizationSettingsModel = z.object({
    openIdConnectConfiguration: z
        .union([authorizeUrlModel, openIdConnectConfigurationModel])
        .nullable(),
    openIdConnectEnabled: z.boolean(),
    subDomain: z.string().nullable(),
    type: z.string().nullable(),
});

export type AuthorizationSettings = z.infer<typeof authorizationSettingsModel>;
